import React from "react";
import { projects } from "data";
import ProjectDetails from "../ProjectDetails";

const Houzz = React.forwardRef((props, ref) => {
	const houzzData = projects.find((project) => project.name === "Houzz");

	return (
		<div ref={ref}>
			<ProjectDetails project={houzzData} />
		</div>
	);
});

Houzz.displayName = "Houzz";

export default Houzz;
